const bootstrap_alert = () => {};
bootstrap_alert.notice = (message) => {
  $("#alert_placeholder").html(
    `<div class="alert alert-success custom-alert">${message}<a href="#" class="btn-close" data-bs-dismiss="alert"></a><span></span></div>`,
  );
};
bootstrap_alert.error = (message) => {
  $("#alert_placeholder").html(
    `<div class="alert alert-danger custom-alert">${message}<a href="#" class="btn-close" data-bs-dismiss="alert"></a><span></span></div>`,
  );
};

export default bootstrap_alert;
